// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yb1u","question":"styles_question__3eiw2","inputVisibleButton":"styles_inputVisibleButton__GhKuc","note":"styles_note__3SyBU"};